module.exports = __webpack_public_path__ + "img/ic_200_education@3x.74de6425.png";